import React, { useEffect, useState } from "react";
import { CloudRain, AlertTriangle, CalendarClock, Check } from "lucide-react";
import { api } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString([], { weekday: "short", month: "short", day: "numeric", hour: "numeric" });

export function WeatherNotice({ parish, country, chosenWindow, onChooseWindow }) {
  const [n, setN] = useState(null);
  useEffect(() => {
    let live = true;
    api.get("/weather/checkout-notice", { params: { parish, country } }).then(({ data }) => live && setN(data)).catch(() => live && setN(null));
    return () => { live = false; };
  }, [parish, country]);
  if (!n?.show) return null;
  const high = n.level === "high";
  const alt = n.alternative_window_start;
  const picked = chosenWindow && chosenWindow === alt;
  return (
    <div className={`mb-6 flex items-start gap-3 rounded-2xl border px-4 py-3 text-sm ${high ? "border-coral/40 bg-coral/5" : "border-amber-300 bg-amber-50"}`} data-testid="checkout-weather-notice" role="status">
      <span className={`mt-0.5 shrink-0 ${high ? "text-coral" : "text-amber-600"}`}>{high ? <AlertTriangle size={18} /> : <CloudRain size={18} />}</span>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-ink" data-testid="checkout-weather-headline">{high ? "Severe weather may delay deliveries" : "Rain may delay deliveries"} in {n.parish} today</p>
        <p className="text-xs text-muted-foreground mt-0.5">{(n.reasons || []).join("; ")}</p>
        {n.official_alerts?.length > 0 && <p className="text-xs font-semibold text-coral mt-1" data-testid="checkout-weather-official">Official warning: {n.official_alerts.map((a) => a.event).join(", ")}</p>}
        {alt && onChooseWindow && (
          <div className="mt-2 flex flex-wrap items-center gap-2" data-testid="checkout-weather-reschedule">
            <button type="button" onClick={() => onChooseWindow(picked ? null : alt)} data-testid="checkout-weather-choose-window"
              className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-bold transition-colors ${picked ? "bg-emerald text-white" : "bg-ink text-white hover:bg-emerald"}`}>
              {picked ? <Check size={13} /> : <CalendarClock size={13} />} {picked ? `Calmer window chosen · from ${fmt(alt)}` : `Deliver in calmer window · from ${fmt(alt)}`}
            </button>
            {picked && <button type="button" onClick={() => onChooseWindow(null)} className="text-xs underline text-muted-foreground" data-testid="checkout-weather-clear-window">Deliver as soon as possible instead</button>}
          </div>
        )}
        <p className="text-[10px] text-muted-foreground mt-1">AI estimate from the {n.attribution || "MET Norway"} forecast{n.stale ? " (last update delayed)" : ""} — not an official warning. Your price and payment are unaffected; a chosen window is a request our dispatch team honours where possible.</p>
      </div>
    </div>
  );
}
